(function () {
  function positionPairedPanel() {
    const drawer = document.getElementById('cart-bar');
    const paired = drawer?.querySelector(':scope > .cart-paired, :scope > .cart-drawer-inner .cart-body > .cart-paired');
    const body = drawer?.querySelector('.cart-drawer-inner .cart-body');
    if (!drawer || !paired || !body) return;

    if (window.matchMedia('(max-width: 768px)').matches) {
      if (paired.parentElement !== body) body.appendChild(paired);
    } else if (paired.parentElement !== drawer) {
      drawer.insertBefore(paired, drawer.querySelector('.cart-drawer-inner'));
    }
  }

  document.addEventListener('DOMContentLoaded', positionPairedPanel);
  window.addEventListener('resize', positionPairedPanel);

  const cartObserver = new MutationObserver(positionPairedPanel);

  const observeCart = () => {
    const drawer = document.getElementById('cart-bar');
    if (drawer) {
      cartObserver.observe(drawer, {
        childList: true,
        subtree: true
      });
    }
  };

  document.addEventListener('DOMContentLoaded', observeCart);

  const money = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-US',
      {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }
    ).format(cents / 100);
  };

  const modalFrom = (element) =>
    element && element.closest('.paired-quick-view');

  const productData = (modal) =>
    JSON.parse(
      modal.querySelector('[data-paired-product-json]').textContent
    );

  function galleryData(modal) {
    const node = modal.querySelector('[data-paired-gallery-json]');
    if (!node) return [];

    try {
      const data = JSON.parse(node.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Paired gallery JSON error:', error);
      return [];
    }
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[^a-z0-9]+/g, '');
  }

  function getColorGroup(modal) {
    const groups = [...modal.querySelectorAll('[data-paired-option]')];

    return (
      groups.find((group) => {
        const name = String(
          group.dataset.pairedOptionName || ''
        ).trim().toLowerCase();

        return name === 'color' || name === 'colour';
      }) ||
      modal
        .querySelector('.paired-quick-view__value--color')
        ?.closest('[data-paired-option]') ||
      null
    );
  }

  function findGalleryIndexById(gallery, imageId) {
    if (!imageId) return -1;

    return gallery.findIndex(
      (image) => String(image.id) === String(imageId)
    );
  }

  function getColorImages(modal, variant) {
    const gallery = galleryData(modal);

    if (!gallery.length) {
      if (variant?.featured_image?.src) {
        return [{
          id: variant.featured_image.id || '',
          src: variant.featured_image.src,
          thumb: variant.featured_image.src,
          alt: ''
        }];
      }

      return [];
    }

    const colorGroup = getColorGroup(modal);

    // No color option: preserve the old first-four behavior.
    if (!colorGroup) {
      return gallery.slice(0, 4);
    }

    const colorButtons = [
      ...colorGroup.querySelectorAll('[data-paired-value]')
    ];

    const selectedButton = colorGroup.querySelector(
      '[data-paired-value].is-selected'
    );

    if (!selectedButton) {
      return gallery.slice(0, 4);
    }

    const selectedColor =
      selectedButton.dataset.pairedColorValue ||
      selectedButton.dataset.pairedValue ||
      '';

    const selectedColorKey = normalize(selectedColor);

    /*
     * 1. Best case:
     *    Product image alt text or filename contains the color name.
     */
    if (selectedColorKey) {
      const nameMatches = gallery.filter((image) => {
        const searchable = normalize(
          `${image.alt || ''} ${image.src || ''}`
        );

        return searchable.includes(selectedColorKey);
      });

      if (nameMatches.length) {
        return nameMatches.slice(0, 4);
      }
    }

    /*
     * 2. Use each color swatch's featured variant image as a boundary.
     *
     *    Example product.images order:
     *      Nova images...
     *      Sky images...
     *      Aurora images...
     *
     *    The variant featured image marks the start of each group.
     */
    const selectedAnchor = findGalleryIndexById(
      gallery,
      selectedButton.dataset.pairedImageId
    );

    if (selectedAnchor >= 0) {
      const anchors = colorButtons
        .map((button) => ({
          button,
          index: findGalleryIndexById(
            gallery,
            button.dataset.pairedImageId
          )
        }))
        .filter((item) => item.index >= 0)
        .sort((a, b) => a.index - b.index);

      const nextAnchor = anchors.find(
        (item) => item.index > selectedAnchor
      );

      const end =
        nextAnchor?.index ?? gallery.length;

      const grouped = gallery.slice(
        selectedAnchor,
        end
      );

      if (grouped.length) {
        return grouped.slice(0, 4);
      }
    }

    /*
     * 3. Equal-group fallback.
     *
     *    This handles products where Shopify doesn't expose usable
     *    image IDs/alt text, but product images are stored color-by-color.
     */
    const selectedColorIndex = colorButtons.indexOf(selectedButton);

    if (
      selectedColorIndex >= 0 &&
      colorButtons.length > 0
    ) {
      const start = Math.floor(
        (selectedColorIndex * gallery.length) /
        colorButtons.length
      );

      let end = Math.floor(
        ((selectedColorIndex + 1) * gallery.length) /
        colorButtons.length
      );

      if (end <= start) {
        end = Math.min(
          gallery.length,
          start + 1
        );
      }

      const grouped = gallery.slice(
        start,
        end
      );

      if (grouped.length) {
        return grouped.slice(0, 4);
      }
    }

    /*
     * 4. Last fallback:
     *    at least show the selected variant image.
     */
    const variantImageId =
      variant?.featured_image?.id;

    const variantGalleryIndex =
      findGalleryIndexById(
        gallery,
        variantImageId
      );

    if (variantGalleryIndex >= 0) {
      return gallery.slice(
        variantGalleryIndex,
        variantGalleryIndex + 4
      );
    }

    if (variant?.featured_image?.src) {
      return [{
        id: variant.featured_image.id || '',
        src: variant.featured_image.src,
        thumb: variant.featured_image.src,
        alt: ''
      }];
    }

    return gallery.slice(0, 4);
  }

  function renderVariantThumbnails(modal, variant) {
    const mainImage = modal.querySelector(
      '[data-paired-main-image]'
    );

    const thumbsContainer = modal.querySelector(
      '[data-paired-thumbs]'
    );

    if (!mainImage) return;

    const images = getColorImages(
      modal,
      variant
    );

    /*
     * Main product image always follows the exact selected variant first.
     */
    if (variant?.featured_image?.src) {
      mainImage.src =
        variant.featured_image.src;
    } else if (images[0]?.src) {
      mainImage.src =
        images[0].src;
    }

    if (!thumbsContainer) return;

    /*
     * IMPORTANT FIX:
     * Rebuild the thumbnail buttons instead of hiding/showing old buttons.
     *
     * This prevents later color groups from remaining hidden because of
     * theme CSS, nth-child rules, or lazy-loaded images that started hidden.
     */
    thumbsContainer.innerHTML = '';

    if (!images.length) {
      return;
    }

    const activeImageId =
      variant?.featured_image?.id
        ? String(variant.featured_image.id)
        : String(images[0]?.id || '');

    images.slice(0, 4).forEach(
      (image, index) => {
        const button =
          document.createElement('button');

        button.type = 'button';
        button.className =
          'paired-quick-view__thumb';

        button.dataset.pairedImage =
          image.src;

        if (image.id != null) {
          button.dataset.pairedImageId =
            String(image.id);
        }

        const isActive =
          String(image.id || '') ===
          activeImageId;

        if (
          isActive ||
          (!activeImageId && index === 0)
        ) {
          button.classList.add(
            'is-active'
          );
        }

        const img =
          document.createElement('img');

        img.src =
          image.thumb ||
          image.src;

        img.alt =
          image.alt || '';

        img.loading = 'eager';

        button.appendChild(img);
        thumbsContainer.appendChild(button);
      }
    );

    /*
     * If selected variant image was not one of the group thumbnails,
     * use the first thumbnail as active while keeping exact main image.
     */
    if (
      !thumbsContainer.querySelector(
        '.paired-quick-view__thumb.is-active'
      )
    ) {
      thumbsContainer
        .querySelector(
          '.paired-quick-view__thumb'
        )
        ?.classList.add('is-active');
    }
  }

  function setModalState(modal) {
    const product = productData(modal);

    const selected = [
      ...modal.querySelectorAll(
        '[data-paired-option]'
      )
    ].map(
      (group) =>
        group.querySelector(
          '.is-selected'
        )?.dataset.pairedValue
    );

    const variant =
      product.variants.find(
        (item) =>
          item.options.every(
            (value, index) =>
              value === selected[index]
          )
      ) ||
      product.variants[0];

    modal.querySelector(
      '[data-paired-variant-id]'
    ).value =
      variant.id;

    const price =
      modal.querySelector(
        '[data-paired-price]'
      );

    if (
      price.dataset.discountUnlocked ===
      'true'
    ) {
      price.innerHTML =
        `<s>${money(variant.price)}</s>` +
        `<strong>${money(
          Math.round(
            variant.price * 0.9
          )
        )}</strong>`;
    } else {
      price.innerHTML =
        `<strong>${money(
          variant.price
        )}</strong>`;
    }

    const add =
      modal.querySelector(
        '.paired-quick-view__add'
      );

    add.disabled =
      !variant.available;

    add.textContent =
      variant.available
        ? 'Add to cart'
        : 'Sold out';

    /*
     * Only new functionality:
     * main image + thumbnails update with selected color variant.
     */
    renderVariantThumbnails(
      modal,
      variant
    );
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.hidden = true;

    document.body.classList.remove(
      'paired-quick-view-open'
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      const opener =
        event.target.closest(
          '[data-paired-open]'
        );

      if (opener) {
        const modal =
          document.getElementById(
            opener.dataset.pairedOpen
          );

        if (modal) {
          modal.hidden = false;

          document.body.classList.add(
            'paired-quick-view-open'
          );

          setModalState(modal);
        }

        return;
      }

      if (
        event.target.closest(
          '[data-paired-close]'
        )
      ) {
        return closeModal(
          modalFrom(event.target)
        );
      }

      const thumb =
        event.target.closest(
          '[data-paired-image]'
        );

      if (thumb) {
        const modal =
          modalFrom(thumb);

        if (!modal) return;

        const mainImage =
          modal.querySelector(
            '[data-paired-main-image]'
          );

        if (mainImage) {
          mainImage.src =
            thumb.dataset.pairedImage;
        }

        modal
          .querySelectorAll(
            '.paired-quick-view__thumb'
          )
          .forEach(
            (item) =>
              item.classList.toggle(
                'is-active',
                item === thumb
              )
          );

        return;
      }

      const value =
        event.target.closest(
          '[data-paired-value]'
        );

      if (value) {
        const group =
          value.closest(
            '[data-paired-option]'
          );

        if (!group) return;

        group
          .querySelectorAll(
            '[data-paired-value]'
          )
          .forEach(
            (item) =>
              item.classList.toggle(
                'is-selected',
                item === value
              )
          );

        const label =
          group.querySelector(
            '[data-paired-option-value]'
          );

        if (label) {
          label.textContent =
            value.dataset.pairedValue;
        }

        setModalState(
          modalFrom(value)
        );

        return;
      }

      const quantityButton =
        event.target.closest(
          '[data-paired-quantity]'
        );

      if (quantityButton) {
        const input =
          quantityButton.parentElement
            .querySelector('input');

        input.value =
          Math.max(
            1,
            Math.min(
              20,
              Number(
                input.value || 1
              ) +
                (
                  quantityButton
                    .dataset
                    .pairedQuantity ===
                  'plus'
                    ? 1
                    : -1
                )
            )
          );
      }
    }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Escape'
      ) {
        closeModal(
          document.querySelector(
            '.paired-quick-view:not([hidden])'
          )
        );
      }
    }
  );

  document.addEventListener(
    'submit',
    async (event) => {
      const form =
        event.target.closest(
          '[data-paired-form]'
        );

      if (!form) return;

      event.preventDefault();

      const modal =
        modalFrom(form);

      const button =
        form.querySelector(
          '.paired-quick-view__add'
        );

      const error =
        form.querySelector(
          '[data-paired-error]'
        );

      button.disabled = true;

      button.textContent =
        'Adding…';

      error.hidden = true;

      try {
        const response =
          await fetch(
            window.routes
              ?.cart_add_url ||
              '/cart/add.js',
            {
              method: 'POST',

              headers: {
                Accept:
                  'application/json'
              },

              body:
                new FormData(form)
            }
          );

        const data =
          await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            'Unable to add this item.'
          );
        }

        closeModal(modal);

        if (
          window.Sls
            ?.updateCart
        ) {
          window.Sls.updateCart();
        }
      } catch (exception) {
        error.textContent =
          exception.message;

        error.hidden =
          false;

        setModalState(
          modal
        );
      }
    }
  );
})();